import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldAlert } from '@dixa/lib-shared-habla';
import { userModalActions, } from 'components/usersModal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
export const UserModalFieldAlert = ({ field, userId, }) => {
    const dispatch = useAppDispatch();
    const alert = `${field} is already used by another user`;
    if (!userId) {
        return _jsx(_Fragment, { children: alert });
    }
    return (_jsxs("span", { children: [alert, _jsx(FieldAlert.Button, Object.assign({ onClick: () => dispatch(userModalActions.user.get({ userId })) }, { children: "Load the user" }))] }));
};
